document.addEventListener('DOMContentLoaded', function() {
  const expressDeliveryCheckbox = document.getElementById('ec-entrega-expressa');
  
  if (expressDeliveryCheckbox) {
    const urlParams = new URLSearchParams(window.location.search);
    const hasExpressFilter = urlParams.has('filter.p.m.custom.entrega_expressa');
    
    if (hasExpressFilter && urlParams.get('filter.p.m.custom.entrega_expressa') === '1') {
      expressDeliveryCheckbox.checked = true;
    }
    
    expressDeliveryCheckbox.addEventListener('change', function() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      
      if (this.checked) {
        params.set('filter.p.m.custom.entrega_expressa', '1');
      } else {
        params.delete('filter.p.m.custom.entrega_expressa');
      }
      
      url.search = params.toString();
      
      window.location.href = url.toString();
    });
  }
});